import { useState } from 'react'
import axios from 'axios'
import { useToast } from '@chakra-ui/react'
import { useQuery } from 'react-query'

const fetchFornecedoresLayout = async (codigo_produto, tipo_pesquisa) => {
  if (!codigo_produto || !tipo_pesquisa) return []

  const response = await axios.get('https://api.innovationbrindes.com.br/api/site/v2/fluxo-layout/consultar-fornecedores-layout', {
    params: {
      codigo_produto,
      tipo_pesquisa,
    },
  })

  return response.data
}

export function useConsultarFornecedorLayout() {
  const toast = useToast()
  const [parametros, setParametros] = useState({ codigo_produto: '', tipo_pesquisa: '' })

  const {
    data = [],
    isLoading,
    isError,
    error,
  } = useQuery(
    ['fornecedoresLayout', parametros.codigo_produto, parametros.tipo_pesquisa],
    () => fetchFornecedoresLayout(parametros.codigo_produto, parametros.tipo_pesquisa),
    {
      enabled: !!(parametros.codigo_produto && parametros.tipo_pesquisa), // Só executa com ambos os parâmetros
      onSuccess: (data) => {
        if (data.length === 0) {
          toast({
            title: 'Nenhum fornecedor encontrado',
            description: 'Não foram encontrados fornecedores com os parâmetros informados',
            status: 'info',
            duration: 3000,
            isClosable: true,
          })
        }
      },
      onError: (error) => {
        console.error('Erro ao consultar fornecedores:', error)
        toast({
          title: 'Erro na consulta',
          description: error.response?.data?.message || 'Ocorreu um erro ao consultar os fornecedores',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      },
      retry: 1,
      staleTime: 1000 * 60 * 5, // Dados ficam "frescos" por 5 minutos
    }
  )

  const consultarFornecedores = (codigo_produto, tipo_pesquisa) => {
    setParametros({ codigo_produto, tipo_pesquisa })
  }

  return {
    dados: data,
    loading: isLoading,
    error: isError ? error : null,
    consultarFornecedores,
  }
}
